var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0296 25L19.9463 35.0833L14.5833 30.793L9.04964 35.2199L6.44674 31.9663L14.5833 25.457L19.6371 29.5L27.0833 22.0537L30.0296 25Z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2473 6.25L25 6.25V10.4167H18.3333C16.5488 10.4167 15.3357 10.4183 14.398 10.4949C13.4846 10.5695 13.0175 10.7048 12.6917 10.8708C11.9077 11.2703 11.2703 11.9077 10.8708 12.6917C10.7048 13.0175 10.5695 13.4846 10.4949 14.398C10.4183 15.3357 10.4167 16.5488 10.4167 18.3333V31.6667C10.4167 33.4512 10.4183 34.6643 10.4949 35.602C10.5695 36.5154 10.7048 36.9825 10.8708 37.3083C11.2703 38.0923 11.9077 38.7297 12.6917 39.1292C13.0175 39.2952 13.4846 39.4305 14.398 39.5051C15.3357 39.5817 16.5488 39.5833 18.3333 39.5833H31.6667C33.4512 39.5833 34.6643 39.5817 35.602 39.5051C36.5154 39.4305 36.9825 39.2952 37.3083 39.1292C38.0923 38.7297 38.7297 38.0923 39.1292 37.3083C39.2952 36.9825 39.4305 36.5154 39.5051 35.602C39.5817 34.6643 39.5833 33.4512 39.5833 31.6667V25H43.75V31.7528C43.75 33.4298 43.75 34.8138 43.6579 35.9413C43.5623 37.1123 43.3569 38.1888 42.8417 39.1999C42.0428 40.7679 40.7679 42.0428 39.1999 42.8417C38.1888 43.3569 37.1123 43.5623 35.9413 43.6579C34.8138 43.75 33.4298 43.75 31.7528 43.75H18.2472C16.5702 43.75 15.1862 43.75 14.0587 43.6579C12.8877 43.5623 11.8112 43.3569 10.8001 42.8417C9.23206 42.0428 7.95723 40.7679 7.15828 39.1999C6.64309 38.1888 6.43775 37.1123 6.34207 35.9413C6.24995 34.8138 6.24997 33.4297 6.25 31.7527V18.2473C6.24997 16.5703 6.24995 15.1862 6.34207 14.0587C6.43775 12.8877 6.64309 11.8112 7.15828 10.8001C7.95723 9.23206 9.23206 7.95723 10.8001 7.15828C11.8112 6.64309 12.8877 6.43775 14.0587 6.34207C15.1862 6.24995 16.5703 6.24997 18.2473 6.25Z",
    fill: "#E7E7E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7927 14.4635L34.9377 9.34302M34.9377 9.34302L39.8552 14.2321M34.9377 9.34302V21.9211",
    stroke: "#E7E7E7",
    strokeWidth: 4.375,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadBig);
export default __webpack_public_path__ + "static/media/FileUploadBig.f9fd814305bf040d6c522cbddbd78dba.svg";
export { ForwardRef as ReactComponent };